<div class="container">
  <div class="row my-5">
    <div class="row">
      <input type="text" class="form-control token_input" [(ngModel)]="token" (keyup.enter)="setToken()">
    </div>
    <div class="row">
      <button class="btn token_btn" (click)="setToken()">Set Token</button>
    </div>
  </div>
</div>
